import { render, staticRenderFns } from "./EducationalCategoriesTree.vue?vue&type=template&id=c9389b56&"
import script from "./EducationalCategoriesTree.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoriesTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports